import { Monitor, Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SegmentedControl } from "@/components/vroom/segmented-control";
import { useTheme, type Theme } from "@/components/theme-provider";

export function AppearanceSection() {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();
  return (
    <div className="grid gap-2">
      <span className="font-mono text-[9.5px] uppercase tracking-[.12em] text-ink-500">
        {t("appearance.heading")}
      </span>
      <SegmentedControl<Theme>
        ariaLabel={t("appearance.aria-label")}
        value={theme}
        onValueChange={setTheme}
        options={[
          {
            value: "light",
            label: (
              <span className="inline-flex items-center gap-1.5">
                <Sun size={14} /> {t("appearance.light.label")}
              </span>
            ),
          },
          {
            value: "dark",
            label: (
              <span className="inline-flex items-center gap-1.5">
                <Moon size={14} /> {t("appearance.dark.label")}
              </span>
            ),
          },
          {
            value: "system",
            label: (
              <span className="inline-flex items-center gap-1.5">
                <Monitor size={14} /> {t("appearance.system.label")}
              </span>
            ),
          },
        ]}
      />
    </div>
  );
}
